import { Component, OnInit } from '@angular/core';

import { DatePipe } from '@angular/common';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { ReporteService } from 'src/app/service/reporte.service';

@Component({
  selector: 'app-verificar',
  templateUrl: './verificar.component.html',
  styleUrls: ['./verificar.component.scss']
})

export class VerificarComponent implements OnInit {

  constructor(
    private utilitarioService:UtilitarioService,
    private globalVariablesService: GlobalVariablesService,
    private reporteService:ReporteService,){
  }

  nroconstancia:string;
  nombres:string;
  fecha:string;
  b_esnro:boolean=true;
  b_esnombres:boolean=true;

  res_nro:String;
  res_nombres:String;
  res_curso:String;
  res_fecha:String;
  res_nota:String;
  resultadook :boolean=false;
  resultadoerror : boolean=false;

  ngOnInit(): void {

    var datePipe = new DatePipe("en-US");
    var hoy = new Date();
    this.fecha = datePipe.transform(hoy, 'yyyy-MM-dd');
  }

  Verificar()
  {
    if(this.b_esnombres && this.b_esnro)
    {
      this.utilitarioService.toastrError('Ingrese un numero de constancia o los nombres y apellidos.');
      return false;
    }

    var esnro = '0';
    var dato = this.nombres;
    if(this.b_esnro)
    {
      esnro = '1';
      dato= this.nroconstancia;
    }


    this.utilitarioService.loading = true;
    this.reporteService.getVerificacion(dato, this.fecha, esnro).subscribe(data=>{
      this.utilitarioService.loading = false;
      var cero = 0 as Number;
      if(data.c_constancia!=cero)
      {
        this.resultadook = true;
        this.res_nro = data.x_nro_constancia;
        this.res_nombres = data.x_nombres;
        this.res_curso = data.x_curso;
        this.res_fecha = data.f_constancia;
        this.res_nota = data.x_nota;
        this.resultadoerror=false;
      }
      else
      {
        this.resultadoerror=true;
        this.resultadook = false;
      }

    });

  }

  Limpiar()
  {
    this.nroconstancia='';
    this.b_esnro = true;
    this.nombres='';
    this.b_esnombres = true;


    this.resultadoerror=false;
    this.resultadook = false;
  }

  onEscribeNro()
  {
    if(this.nroconstancia.length>0)
      this.b_esnombres = false;
    else
      this.b_esnombres = true;
  }

  onEscribeNombres()
  {
    if(this.nombres.length>0)
      this.b_esnro = false;
    else
      this.b_esnro = true;
  }

}
